import memoizeOne from 'memoize-one';
import { dateOptimisticUpdatesHandler } from '../field-types/date/bulk-edit-transform/index.tsx';
import { dateTimeOptimisticUpdatesHandler } from '../field-types/datetime/bulk-edit-transform/index.tsx';
import { labelsOptimisticUpdatesHandler } from '../field-types/labels/bulk-edit-transform/index.tsx';
import { multiSelectOptimisticUpdatesHandler } from '../field-types/multi-select/bulk-edit-transform/index.tsx';
import { numberOptimisticUpdatesHandler } from '../field-types/number/bulk-edit-transform/index.tsx';
import { parentOptimisticUpdatesHandler } from '../field-types/parent/bulk-edit-transform/index.tsx';
import { priorityOptimisticUpdatesHandler } from '../field-types/priority/bulk-edit-transform/index.tsx';
import { singleSelectOptimisticUpdatesHandler } from '../field-types/single-select/bulk-edit-transform/index.tsx';
import { textOptimisticUpdatesHandler } from '../field-types/text/bulk-edit-transform/index.tsx';
import { urlOptimisticUpdatesHandler } from '../field-types/url/bulk-edit-transform/index.tsx';
import { userOptimisticUpdatesHandler } from '../field-types/user/bulk-edit-transform/index.tsx';
import { versionOptimisticUpdatesHandler } from '../field-types/version/bulk-edit-transform/index.tsx';
import type { ListIssueField } from '../types.tsx';
import type { DataTransformFn } from './types.tsx';

const createSupportedBulkEditTransformations = memoizeOne(() => ({
	...priorityOptimisticUpdatesHandler,
	...userOptimisticUpdatesHandler,
	...labelsOptimisticUpdatesHandler,
	...dateOptimisticUpdatesHandler,
	...dateTimeOptimisticUpdatesHandler,
	...multiSelectOptimisticUpdatesHandler,
	...numberOptimisticUpdatesHandler,
	...parentOptimisticUpdatesHandler,
	...versionOptimisticUpdatesHandler,
	...singleSelectOptimisticUpdatesHandler,
	...urlOptimisticUpdatesHandler,
	...textOptimisticUpdatesHandler,
}));

export const transformFieldForOptimisticUpdates = (
	fieldType: string,
	...args: Parameters<DataTransformFn<ListIssueField>>
): ReturnType<DataTransformFn<ListIssueField>> | undefined => {
	const handlers = createSupportedBulkEditTransformations();
	if (!handlers[fieldType]) {
		return;
	}

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return (handlers[fieldType] as DataTransformFn<ListIssueField>)(...args);
};

export const isOptimisticUpdateSupported = (fieldType: string) => {
	const handlers = createSupportedBulkEditTransformations();
	return handlers[fieldType] !== null;
};
